import { InjectionToken, Type } from '@angular/core';

/** Shell record page component used when opening manage records in modals. */
export const MANAGE_RECORD_PAGE = new InjectionToken<Type<unknown>>(
  'ManageRecordPage',
);
